export const pageContainer = {
  minW: 'full',
  m: '0',
  p: '0',
  bgColor: 'gray.900',
  height: '100%',
  textAlign: ['center'],
};
